import {
  CssBaseline,
  ThemeProvider,
  styled,
  Typography,
  Box,
  Menu,
  MenuItem,
  Divider,
  IconButton,
  Dialog,
  List,
  ListItemButton,
  useMediaQuery,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import theme from "../../config/theme";
import { Link, NavLink, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import Ledgerhome from "../../assets/Ledgerhome.png";
import Dockethome from "../../assets/Dockethome.png";
import Bitehome from "../../assets/Bitehome.png";
import logo from "../../assets/logo.png";
import navbarMenu from "../../assets/navbarmenu.png";
import { Close } from "@mui/icons-material";
import { StyledButton } from "../common/Button";
import products from "../../constants/products";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: "1.5rem",
    color: theme.palette.text.primary,
    boxShadow: "0 20px 40px rgba(99, 102, 241, 0.15), 0 8px 16px rgba(0, 0, 0, 0.1)",
    backdropFilter: "blur(10px)",
    background: "rgba(255, 255, 255, 0.95)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    "& .MuiMenu-list": {
      display: "flex",
    },
    "& .MuiMenuItem-root": {
      flex: "1 0 33.33%",
    },
  },
}));

const CustomizedTypography = styled(Typography)({
  display: "flex",
  justifyContent: "flex-end",
  gap: "3.75rem",
  fontSize: "0.875rem",
  fontWeight: "600",
  letterSpacing: "0.05em",
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
});

const CustomizedNavLink = styled(NavLink)(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: "none",
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: 600,
  letterSpacing: "0.05em",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  position: "relative",
  "&:hover": {
    color: theme.palette.primary.main,
    transform: "translateY(-1px)",
  },
  "&.active": {
    color: theme.palette.primary.main,
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: "-4px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "20px",
      height: "2px",
      backgroundColor: theme.palette.primary.main,
      borderRadius: "1px",
    },
  },
}));

const navLinks = [
  {
    title: "HOME",
    links: [{ path: "/" }],
  },
  {
    title: "PRODUCTS",
    links: [{ path: "/products" }],
  },
  {
    title: "PLANS",
    links: [{ path: "/plans" }],
  },
  {
    title: "GET IN TOUCH",
    links: [{ path: "/contact" }],
  },
];

const subNavLinks = [
  {
    title: "Ledger",
    link: [{ path: "/ledger" }],
  },
  {
    title: "Docket",
    link: [{ path: "/docket" }],
  },
  {
    title: "Bite",
    link: [{ path: "/bite" }],
  },
];

const menuData = [
  {
    img: Ledgerhome,
    description: ["Cash Register - invoice", <br />, "Generator"],
    bgColor: "#EEF6FF",
    link: "/ledger",
  },
  {
    img: Dockethome,
    description: "Timetable Creator",
    bgColor: "#F6E9FF",
    link: "/docket",
  },
  {
    img: Bitehome,
    description: "Canteen Management",
    bgColor: "#E4FFEF",
    link: "/bite",
  },
];

const Navbar = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigate = useNavigate();

  const handleImageClick = (link) => {
    handleClose();
    navigate(link);
  };

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const [subNavVisible, setSubNavVisible] = useState(false);

  const handleSubNavToggle = () => {
    setSubNavVisible(!subNavVisible);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      {isMobile ? (
        <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "1rem 2rem 0rem 2rem ",
          background: "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
          position: "sticky",
          top: 0,
          zIndex: 1000,
        }}
      >
        <Box sx={{ display: "flex", flex: 1}}>
        <CustomizedNavLink to="/">
            <img
              src={logo}
              alt="youstad_logo"
              style={{ height: "2rem" }}
            />
          </CustomizedNavLink>
        </Box>
        <Box sx={{ display: "flex", flex: 1, justifyContent: "flex-end" }}>
        <Box
            sx={{
              display: { xs: "block", sm: "none" },
            }}
          >
            <IconButton onClick={handleDialogOpen}>
              <img src={navbarMenu} alt="" />
            </IconButton>
          </Box>
          <Dialog fullScreen open={isDialogOpen} onClose={handleDialogClose}>
            <Box sx={{ display: "flex", marginTop: "1rem" }}>
              <Box
                sx={{
                  marginLeft: "2rem",
                }}
              >
                <CustomizedNavLink to="/">
                  <img
                    src={logo}
                    alt="youstad_logo"
                    style={{ height: "2rem" }}
                  />
                </CustomizedNavLink>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flex: 1,
                  justifyContent: "flex-end",
                  marginRight: "2rem",
                }}
              >
                <IconButton onClick={handleDialogClose}>
                  <Close />
                </IconButton>
              </Box>
            </Box>
            <React.Fragment>
              <List
                style={{ marginLeft: "2rem" }}
              >
                {navLinks.map((link) => (
                  <React.Fragment key={link.title}>
                    <ListItemButton
                      component="a"
                      href={
                        link.title === "PRODUCTS" ? "#" : link.links[0].path
                      }
                      onClick={
                        link.title === "PRODUCTS"
                          ? handleSubNavToggle
                          : undefined
                      }
                      style={{ paddingLeft: "0" }}
                    >
                      {link.title}
                      {link.title === "PRODUCTS" && <ArrowDropDownIcon/> }
                    </ListItemButton>
                    {link.title === "PRODUCTS" && subNavVisible && (
                      <List>
                        {subNavLinks.map((link) => (
                          <ListItemButton
                            component="a"
                            href={link.link[0].path}
                            key={link.title}
                            style={{ marginLeft: "1.25rem" }}
                          >
                            {link.title}
                          </ListItemButton>
                        ))}
                      </List>
                    )}
                  </React.Fragment>
                ))}
              </List>
              <Box
            style={{ marginTop: "auto", marginBottom: "5rem", marginLeft: "2rem" }}
          >
            <StyledButton
              variant="contained"
              width="10rem"
              height="3rem"
              style={{ backgroundColor: `${theme.palette.primary.main}` }}
              component={Link}
              to={products.ERP}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open Youstad
            </StyledButton>
          </Box>
            </React.Fragment>
          </Dialog>
        </Box>
      </Box>
      ) : (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "1rem 2rem 0rem 2rem ",
          background: "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
          position: "sticky",
          top: 0,
          zIndex: 1000,
        }}
      >
        <Box sx={{ display: "flex", width: "25%" }}>
          <CustomizedNavLink to="/">
            <img
              src={logo}
              alt="youstad_logo"
              style={{ height: "3rem" }}
            />
          </CustomizedNavLink>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", width: "50%" }}>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <CustomizedTypography>
              {navLinks.map((navLink) => (
                <React.Fragment key={navLink.title}>
                  <CustomizedNavLink
                    to={navLink.links[0].path}
                    sx={{ display: "flex", alignItems: "center" }}
                    onMouseOver={
                      navLink.title === "PRODUCTS" ? handleClick : undefined
                    }
                  >
                    {navLink.title}
                  </CustomizedNavLink>
                  {navLink.title === "PRODUCTS" && (
                    <ArrowDropDownIcon
                      sx={{ cursor: "pointer", marginLeft: "-3.1875rem" }}
                      onMouseOver={handleClick}
                    />
                  )}
                </React.Fragment>
              ))}
            </CustomizedTypography>
            <StyledMenu anchorEl={anchorEl} open={open} onClose={handleClose}>
              <div
                style={{ display: "flex", flexDirection: "row" }}
                onMouseLeave={handleClose}
              >
                {menuData.map((item, index) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                    key={index}
                  >
                    <MenuItem
                      onClick={() => handleImageClick(item.link)}
                      disableRipple
                      sx={{ "&:hover": { backgroundColor: "#FFF" } }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          borderRadius: "8px",
                          gap: "2.625rem",
                          "&:hover": { backgroundColor: item.bgColor },
                          margin: "1.125rem 1rem 1.125rem 1rem",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={item.img}
                            alt=""
                            style={{
                              height: "9.375rem",
                              width: "9.84375rem",
                              objectFit: "contain",
                            }}
                          />
                        </Box>
                        <Box>
                          <Typography
                            variant="h5"
                            sx={{
                              marginBottom: "2rem",
                              width: "17rem",
                              fontSize: "0.875rem",
                              fontWeight: "700",
                              letterSpacing: "0.078125rem",
                              textAlign: "center",
                              color: "#212121",
                              textTransform: "uppercase",
                            }}
                          >
                            {item.description}
                          </Typography>
                        </Box>
                      </Box>
                    </MenuItem>
                    {index < menuData.length - 1 && (
                      <Divider
                        orientation="vertical"
                        sx={{
                          backgroundColor: `${theme.palette.primary.main}`,
                          height: "16rem",
                        }}
                      />
                    )}
                  </div>
                ))}
              </div>
            </StyledMenu>
          </Box>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "flex-end", width: "25%" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <StyledButton
              variant="contained"
              width="10rem"
              height="3rem"
              style={{ backgroundColor: `${theme.palette.primary.main}` }}
              component={Link}
              to={products.ERP}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open Youstad
            </StyledButton>
          </Box>
        </Box>
      </Box>)}
    </ThemeProvider>
  );
};

export default Navbar;
